import fetch from '@/utils/fetch'

export function deleteAcsGoods (query) {
  return fetch({
    url: '/goods/acs/del/',
    method: 'delete',
    params: query
  })
}

export function addAcsGoods (data) {
  return fetch({
    url: '/goods/acs/add',
    method: 'post',
    data
  })
}
